import { useAppStore } from "../../hooks/useStores";
import useDesignEditorUtils, { Property } from "../CustomUtils/UseDesignEditor";
import { useEditor } from "./useEditor";

export type UseBrandConfigs = {
	handleUpdateActiveObject: (activeObject: any) => void;
	modifyActiveObjectProperty: (activeObject: any, property: string, value: any) => void;
};

const UseBrandConfigs = (): UseBrandConfigs => {
	const { designEditorStore, campaignStore } = useAppStore();
	const { editBrandConfigrationsInAllAds } = useDesignEditorUtils();
	const editor = useEditor();

	const handleUpdateActiveObject = (activeObject: any) => {
		designEditorStore.setProperty("activeObjectSettings", {
			colorNumber: activeObject?.colorNumber,
			fontType: activeObject?.fontType,
			logoType: activeObject?.logoType,
			horizontalAlignment: activeObject?.horizontalAlignment,
			verticalAlignment: activeObject?.verticalAlignment,
			strokeColorNumber: activeObject?.strokeColorNumber,
			shadowColorNumber: activeObject?.shadowColorNumber,
		});
	};

	const modifyActiveObjectProperty = (activeObject: any, property: string, value: any) => {
		if (activeObject) {
			let newValue = activeObject[property] !== value ? value : undefined;
			if (property === Property.HORIZONTAL_ALIGNMENT || property === Property.VERTICAL_ALIGNMENT) {
				newValue = value;
			}
			activeObject[property] = newValue;
			designEditorStore.setProperty("activeObjectSettings", {
				colorNumber: activeObject?.colorNumber,
				fontType: activeObject?.fontType,
				logoType: activeObject?.logoType,
				horizontalAlignment: activeObject?.horizontalAlignment,
				verticalAlignment: activeObject?.verticalAlignment,
				strokeColorNumber: activeObject?.strokeColorNumber,
				shadowColorNumber: activeObject?.shadowColorNumber,
				[property]: activeObject[property],
			});
			editBrandConfigrationsInAllAds(activeObject, property, newValue);
			editor?.canvas.canvas.fire("object:modified", {
				target: activeObject,
				invokeSave: !campaignStore.isEditingAllAds,
			});
		}
	};

	return {
		handleUpdateActiveObject,
		modifyActiveObjectProperty,
	};
};

export default UseBrandConfigs;
